import * as yup from "yup";
import { checkValidURL } from "../../../utils/helpers/text";

export const topBannerMessageValidationSchemaFactory = () => {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  return yup.object({
    site: yup.string("Enter site").typeError("Enter site").required("Enter site"),
    color: yup.string("Select the color").typeError("Select the color").required("Select the color"),
    heading: yup
      .string("Enter title")
      .trim("You must add at least one character that will not be a space")
      .min(1, "You must add at least one character that will not be a space")
      .typeError("Enter title")
      .required("Enter title"),
    displayText: yup
      .string("Enter text to display")
      .typeError("Enter text to display")
      .required("Enter text to display")
      .nullable(),
    infoURL: yup
      .string("Invalid link, should be a valid URL, e.g. https://roche.com")
      .typeError("Invalid link, should be a valid URL, e.g. https://roche.com")
      .test({
        message: "Invalid link, should be a valid URL, e.g. https://roche.com",
        test: (value) => {
          return (value ?? "").length === 0 || checkValidURL(value);
        }
      })
      .nullable(),
    app: yup.string("Enter app").typeError("Enter app").required("Enter app"),
    from: yup
      .date()
      .min(now, "Start date cannot be before today")
      .typeError("Provide date in correct format dd-MMM-yyyy")
      .required("Enter from date"),
    to: yup
      .date()
      .min(now, "End date cannot be before today")
      .typeError("Provide date in correct format dd-MMM-yyyy")
      .required("Enter to date")
  });
};
